import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { getStorage } from 'firebase/storage'

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)

export const auth = getAuth(app)
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager(),
  }),
})
export const storage = getStorage(app)
export default app

export const COLLECTIONS = {
  products: 'products',
  orders: 'orders',
  customers: 'customers',
  customerByEmail: 'customerByEmail',
  customerByPhone: 'customerByPhone',
  banners: 'banners',
  coupons: 'coupons',
  categories: 'categories',
  rawMaterials: 'rawMaterials',
  settings: 'settings',
  adminFcmTokens: 'adminFcmTokens',
  contactSubmissions: 'contactSubmissions',
  productRequests: 'productRequests',
  bugReports: 'bugReports',
  orderReturnRequests: 'orderReturnRequests',
  ratingsAndReviews: 'ratingsAndReviews',
} as const

export const isFirebaseConfigured = (): boolean =>
  Boolean(
    import.meta.env.VITE_FIREBASE_API_KEY &&
      import.meta.env.VITE_FIREBASE_PROJECT_ID
  )

export const getAdminEmails = (): string[] => {
  const raw = import.meta.env.VITE_ADMIN_EMAILS || ''
  return raw
    .split(',')
    .map((e: string) => e.trim().toLowerCase())
    .filter(Boolean)
}
